module.exports = __webpack_public_path__ + "static/Aguilas-Del-Desierto-3be05134063a91c6c2ae267bf95ce914.jpg";